"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _DefinedUserPreference = _interopRequireDefault(require("../model/DefinedUserPreference"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
* PreferenceDefinitions service.
* @module api/PreferenceDefinitionsApi
* @version 1.1.3-alpha.1
*/
class PreferenceDefinitionsApi {
  /**
  * Constructs a new PreferenceDefinitionsApi. 
  * @alias module:api/PreferenceDefinitionsApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  constructor(apiClient) {
    this.apiClient = apiClient || _ApiClient.default.instance;
  }

  /**
   * Get preference definition
   * Returns the requested preference definition
   * @param {Number} id Id of the preference definition to get
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/DefinedUserPreference} and HTTP response
   */
  getWithHttpInfo(id) {
    let postBody = null;
    // verify the required parameter 'id' is set
    if (id === undefined || id === null) {
      throw new Error("Missing the required parameter 'id' when calling get");
    }
    let pathParams = {
      'id': id
    };
    let queryParams = {};
    let headerParams = {};
    let formParams = {};
    let authNames = [];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = _DefinedUserPreference.default;
    return this.apiClient.callApi('/api/v1/PreferenceDefinitions/{id}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
  }

  /**
   * Get preference definition
   * Returns the requested preference definition
   * @param {Number} id Id of the preference definition to get
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/DefinedUserPreference}
   */
  get(id) {
    return this.getWithHttpInfo(id).then(function (response_and_data) {
      return response_and_data.data;
    });
  }

  /**
   * Get multiple preference definitions
   * Returns an array of requested preference definitions
   * @param {Object} opts Optional parameters
   * @param {Array.<Number>} opts.request_body Ids of the preference definitions to get. Not specifiying ids will return all preference definitions
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/DefinedUserPreference>} and HTTP response
   */
  getManyWithHttpInfo(opts) {
    opts = opts || {};
    let postBody = opts['request_body'];
    let pathParams = {};
    let queryParams = {};
    let headerParams = {};
    let formParams = {};
    let authNames = [];
    let contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    let accepts = ['application/json'];
    let returnType = [_DefinedUserPreference.default];
    return this.apiClient.callApi('/api/v1/PreferenceDefinitions/getMany', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
  }

  /**
   * Get multiple preference definitions
   * Returns an array of requested preference definitions
   * @param {Object} opts Optional parameters
   * @param {Array.<Number>} opts.request_body Ids of the preference definitions to get. Not specifiying ids will return all preference definitions
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/DefinedUserPreference>}
   */
  getMany(opts) {
    return this.getManyWithHttpInfo(opts).then(function (response_and_data) {
      return response_and_data.data;
    });
  }
}
exports.default = PreferenceDefinitionsApi;